import { Link } from 'react-router-dom';
import { Instagram, Mail, MapPin, Phone } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_087dcaaa-f596-41d4-9f4c-171b9ddad075/artifacts/wvrmtjxe_LOGO%20DR%20EDU%20HADAS.PNG";
const WHATSAPP_LINK = "https://wa.me/5541988451399?text=Olá,%20gostaria%20de%20agendar%20uma%20avaliação%20médica.";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#2A2A2A] text-white">
      <div className="container-custom py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img 
              src={LOGO_URL} 
              alt="Dr. Eduardo Hadas" 
              className="h-14 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              Medicina ética premium. Humana, responsável, baseada em ciência e cuidado de longo prazo.
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="https://www.instagram.com/dreduhadas/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:border-[#B8944D] hover:text-[#B8944D] transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links Column */}
          <div>
            <h4 className="text-lg font-medium mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
              Navegação
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="footer-link text-sm">Início</Link>
              </li>
              <li>
                <Link to="/sobre" className="footer-link text-sm">Sobre o Dr. Eduardo</Link>
              </li>
              <li>
                <Link to="/emagrecimento" className="footer-link text-sm">Emagrecimento Clínico</Link>
              </li>
              <li>
                <Link to="/reposicao-hormonal" className="footer-link text-sm">Reposição Hormonal</Link>
              </li>
              <li>
                <Link to="/como-funciona" className="footer-link text-sm">Como Funciona</Link>
              </li>
              <li>
                <Link to="/blog" className="footer-link text-sm">Blog</Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-lg font-medium mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
              Contato
            </h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href={WHATSAPP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="footer-link text-sm flex items-start gap-3"
                >
                  <Phone className="w-4 h-4 mt-1 flex-shrink-0" />
                  <span>(41) 98845-1399</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:dreduardohadas@gmail.com"
                  data-testid="footer-email"
                  className="footer-link text-sm flex items-start gap-3"
                >
                  <Mail className="w-4 h-4 mt-1 flex-shrink-0" />
                  <span>dreduardohadas@gmail.com</span>
                </a>
              </li>
              <li>
                <a 
                  href="https://maps.google.com/?q=R.+André+Ferreira+Barbosa,+8157+-+Pinheirinho,+Curitiba+-+PR"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-address"
                  className="footer-link text-sm flex items-start gap-3"
                >
                  <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                  <span>R. André Ferreira Barbosa, 8157<br />Pinheirinho, Curitiba - PR<br />CEP: 81150-040</span>
                </a>
              </li>
            </ul>
          </div>

          {/* CTA Column */}
          <div>
            <h4 className="text-lg font-medium mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
              Agende sua avaliação
            </h4>
            <p className="text-white/70 text-sm mb-6">
              O primeiro passo para um tratamento médico sério começa aqui.
            </p>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-cta-button"
              className="btn-primary inline-flex items-center gap-2"
            >
              <Phone className="w-4 h-4" />
              Agendar avaliação
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} Dr. Eduardo Hadas — CRM-PR 40929. Todos os direitos reservados.
          </p>
          <p className="text-white/50 text-xs">
            Este site não substitui uma consulta médica.
          </p>
        </div>
      </div>
    </footer>
  );
};
